export const HOME_SCREEN = 'Home';
export const AUTHENTICATE = 'Authenticate';